import React, { useContext, useEffect, useState } from "react";

export const Header = ({ IconName, subText, mainText, postComponent }) => {

    return (<>
        <div className="flex flex-row p-3 gap-4 items-center mb-4 bg-white rounded text-gray-500">
            <IconName className="w-10 h-10 " />
            <div className="flex flex-col flex-1">
                <div className="text-xs">{subText}</div>
                <h4 className="text text-bold ">{mainText}</h4>
            </div>
            {postComponent && <div className="flex flex-col">
                {postComponent}
            </div>}
        </div>
    </>
    );
}
